import { render, staticRenderFns } from "./ConfigAlertAmazonSns.vue?vue&type=template&id=97d45d40&scoped=true"
import script from "./ConfigAlertAmazonSns.vue?vue&type=script&lang=js"
export * from "./ConfigAlertAmazonSns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d45d40",
  null
  
)

export default component.exports